var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowPointer = function SvgArrowPointer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.056 14.4H18l-.004-1.2v-.375L7.2 3.6 6 4.159v14.44l.27.297.818.896.768-.937 3.158-3.848 2.239 5.04 1.095-.487zm-1.477-.761L7.2 17.759V5.18l9.386 8.02h-5.643l-.36.44z"
  })));
};
export default SvgArrowPointer;